export * from "./col-profile-card.component";
